import BulletList from "../../Atoms/BulletList";

interface Props {
  title?: string;
  items: React.ReactNode[];
}

export default function ListSection({ title, items }: Props) {
  return items && items.filter((t) => t !== "").length > 0 ? (
    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      {title && <b className="DetailTitle">{title}</b>}

      <BulletList items={items} />
    </div>
  ) : null;
}
